export default "__VITE_ASSET__252de684__"